/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const DetailPricePolicyPage = lazyLoad(
  () => import('./index'),
  module => module.DetailPricePolicyPage
);
